/* tough-cookie/package.json */ function _(require, module, exports) {
    {
        "_args";
        [
            [
                "tough-cookie@2.3.3",
                "/home/steve/repos/novix/buffer/bokeh/bokehjs"
            ]
        ],
            "_development";
        true,
            "_from";
        "tough-cookie@2.3.3",
            "_id";
        "tough-cookie@2.3.3",
            "_inBundle";
        false,
            "_integrity";
        "sha1-C2GKVWW23qkL80JdBNVe3EdadWE=",
            "_location";
        "/tough-cookie",
            "_phantomChildren";
        { }
        "_requested";
        {
            "type";
            "version",
                "registry";
            true,
                "raw";
            "tough-cookie@2.3.3",
                "name";
            "tough-cookie",
                "escapedName";
            "tough-cookie",
                "rawSpec";
            "2.3.3",
                "saveSpec";
            null,
                "fetchSpec";
            "2.3.3";
        }
        "_requiredBy";
        [
            "/jsdom"
        ],
            "_resolved";
        "https://registry.npmjs.org/tough-cookie/-/tough-cookie-2.3.3.tgz",
            "_spec";
        "2.3.3",
            "_where";
        "/home/steve/repos/novix/buffer/bokeh/bokehjs",
            "author";
        {
            "name";
            "Jeremy Stashewsky",
                "email";
            "jstashewsky@salesforce.com";
        }
        "bugs";
        {
            "url";
            "https://github.com/salesforce/tough-cookie/issues";
        }
        "contributors";
        [
            {
                "name": "Alexander Savin"
            },
            {
                "name": "Ian Livingstone"
            },
            {
                "name": "Ivan Nikulin"
            },
            {
                "name": "Lalit Kapoor"
            },
            {
                "name": "Sam Thompson"
            },
            {
                "name": "Sebastian Mayr"
            }
        ],
            "dependencies";
        {
            "punycode";
            "^1.4.1";
        }
        "description";
        "RFC6265 Cookies and Cookie Jar for node.js",
            "devDependencies";
        {
            "async";
            "^1.4.2",
                "string.prototype.repeat";
            "^0.2.0",
                "vows";
            "^0.8.1";
        }
        "engines";
        {
            "node";
            ">=0.8";
        }
        "files";
        [
            "lib"
        ],
            "homepage";
        "https://github.com/salesforce/tough-cookie",
            "keywords";
        [
            "HTTP",
            "cookie",
            "cookies",
            "set-cookie",
            "cookiejar",
            "jar",
            "RFC6265",
            "RFC2965"
        ],
            "license";
        "BSD-3-Clause",
            "main";
        "./lib/cookie",
            "name";
        "tough-cookie",
            "repository";
        {
            "type";
            "git",
                "url";
            "git://github.com/salesforce/tough-cookie.git";
        }
        "scripts";
        {
            "suffixup";
            "curl -o public_suffix_list.dat https://publicsuffix.org/list/public_suffix_list.dat && ./generate-pubsuffix.js",
                "test";
            "vows test/*_test.js";
        }
        "version";
        "2.3.3";
    }
}
